import "intersection-observer";
import "core-js/features/string/match-all";

import "../styles/index.css";
import "../styles/lookbook-feed.css";
import "../styles/lookbook-story.css";
import "../styles/item.css";
import "../styles/media.css";
import "../styles/aspect-ratio.css";
import "../styles/progress.css";
import "../styles/overlay.css";
import "../styles/actions.css";
import "../styles/reactions.css";
import "../styles/play-pause.css";
import "../styles/video.css";

import type { AppProps } from "next/app";
import NextApp from "next/app";
import Head from "next/head";
import type { ErrorInfo } from "react";

import { Sentry } from "../errorHandler";

if (typeof window !== "undefined") {
  document.body.addEventListener("touchstart", () => undefined, false);

  if (typeof Number.parseInt === "undefined") {
    Number.parseInt = window.Number.parseInt;
  }

  if (typeof Number.parseFloat === "undefined") {
    Number.parseFloat = window.Number.parseFloat;
  }
}

function AppHandler({ Component, pageProps }: AppProps) {
  return (
    <>
      <Head>
        <meta charSet="utf-8" />
        <meta
          name="viewport"
          content="viewport-fit=cover, width=device-width, user-scalable=no, initial-scale=1.0, maximum-scale=1.0, shrink-to-fit=no"
        />
      </Head>
      <Component {...pageProps} />
    </>
  );
}

export default class App extends NextApp {
  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    Sentry.withScope((scope) => {
      Object.keys(errorInfo).forEach((key) => {
        scope.setExtra(key, errorInfo[key as keyof ErrorInfo]);
      });

      Sentry.captureException(error);
    });
  }

  render() {
    return <AppHandler {...this.props} />;
  }
}
